/* eslint-disable import/prefer-default-export */
const stripParenthetical = (name: string) =>
  name?.replace(/\s*\(.*?\)/g, '').trim() || '';

export const getFirstName = (fullName: string) => {
  const parts = stripParenthetical(fullName).split(/\s+/).filter(Boolean);
  return parts[0] || '';
};

export const getFirstNameInitial = (fullName: string) => {
  const firstName = getFirstName(fullName);
  return firstName ? firstName.charAt(0).toUpperCase() : '';
};

export const getInitials = (fullName: string) => {
  const nameParts = stripParenthetical(fullName).split(/\s+/).filter(Boolean);
  if (nameParts.length >= 2) {
    return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`.toUpperCase();
  }
  if (nameParts.length === 1 && nameParts[0]) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  return '?';
};
